import type { Expense, Tag } from '../../types';
import type { ExpenseFormData } from '../forms/expense-form';
import { Button } from '../ui/button';
import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';
import { ExpenseForm } from '../forms/expense-form';

interface ExpenseDialogProps {
  open: boolean;
  editingExpense: Expense | null;
  onSubmit: (data: ExpenseFormData) => Promise<void>;
  onClose: () => void;
  tags: Tag[];
  expenseToDelete: Expense | null;
  onDeleteConfirm: () => Promise<void>;
  onDeleteCancel: () => void;
}

export function ExpenseDialog({
  open,
  editingExpense,
  onSubmit,
  onClose,
  tags,
  expenseToDelete,
  onDeleteConfirm,
  onDeleteCancel,
}: ExpenseDialogProps) {
  return (
    <>
      <DialogRoot
        open={open}
        onOpenChange={(isOpen) => {
          if (!isOpen) onClose();
        }}
      >
        <DialogPortal>
          <DialogBackdrop className="z-40" />
          <DialogPopup className="z-41">
            <DialogHeader>
              <DialogTitle>
                {editingExpense ? 'Editar gasto' : 'Novo gasto'}
              </DialogTitle>
              <DialogCloseButton />
            </DialogHeader>
            <DialogContent>
              <ExpenseForm
                onSubmit={onSubmit}
                onClose={onClose}
                initialData={editingExpense}
                availableTags={tags}
              />
            </DialogContent>
          </DialogPopup>
        </DialogPortal>
      </DialogRoot>

      <DialogRoot
        open={!!expenseToDelete}
        onOpenChange={(isOpen) => {
          if (!isOpen) onDeleteCancel();
        }}
      >
        <DialogPortal>
          <DialogBackdrop />
          <DialogPopup className="max-w-sm">
            <DialogHeader>
              <DialogTitle>Confirmar exclusão</DialogTitle>
              <DialogCloseButton />
            </DialogHeader>
            <DialogContent>
              <p className="text-sm text-foreground-subtle">
                Tem certeza que deseja excluir o gasto{' '}
                <strong className="text-foreground">
                  {expenseToDelete?.description}
                </strong>
                ?
              </p>
              <div className="mt-4 flex gap-2">
                <Button
                  variant="outline"
                  className="flex-1"
                  onClick={onDeleteCancel}
                >
                  Cancelar
                </Button>
                <Button
                  variant="destructive"
                  className="flex-1"
                  onClick={onDeleteConfirm}
                >
                  Excluir
                </Button>
              </div>
            </DialogContent>
          </DialogPopup>
        </DialogPortal>
      </DialogRoot>
    </>
  );
}
